import _ from 'lodash';
import React from 'react';
import ReactMapboxGl, { Cluster, Marker, Popup, RotationControl, ScaleControl, ZoomControl } from "react-mapbox-gl";
import ReactQueryParams from 'react-query-params';
import Select from 'react-select';
import { debounce } from 'throttle-debounce';
import './App.css';
import Creative from './components/Creative';
import { customStyles, selectColors } from './helpers.js';

const Map = ReactMapboxGl({
  accessToken: "pk.eyJ1Ijoiam9yaXMtdm9sdGEiLCJhIjoiY2pwbWY5cDhrMGk1aDQybzlmcGkzZ3hjMSJ9.FN0dQoueJIiYvVs88QnfsA",
});

// extends van ReactQueryParams zodat query-filters gebruikt kunnen worden
class App extends ReactQueryParams {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      bounds: [],
      filteredCreatives: [],
      zoom: [10],
      creatives: [],
      filter: '',
      center: [4.402771, 51.260197],
      showPopup: false,
      popupCoordinates: [4.402771, 51.260197],
      activeCreative: null,
      tags: [],
      tagFilter: '',
      intro: '',
      activeKey: null
    };
    this.creativesRef = React.createRef()
  }

  componentDidMount() {
    this.fetchCreatives();
    this.fetchIntro();
  }


  fetchCreatives = () => {
    fetch('/creatives/list', {
      method: 'GET',
    })
      .then((response) => {
        return response.json();
      })
      .then((creatives) => {
        let tags = [];

        creatives.forEach((creative) => {
          if (Array.isArray(creative.tags)) {
            creative.tags.forEach(tag => {
              tags.push(tag);
            });
          }
        });
        // creëer unieke lijst met tags
        tags = _.uniqBy(tags, 'label');

        this.setState({ creatives, filteredCreatives: creatives, loading: false, tags });

        let tag = this.queryParams.tag;
        if (tag) {
          tag = decodeURIComponent(tag);
          const tagFilter = { value: tag, label: tag };
          this.setState({ tagFilter }, this.filterCreatives);
        }
      })
      .catch((error) => {
        console.log(error);
      })
  };

  fetchIntro = () => {
    fetch('/creatives/intro', {
      method: 'GET',
    })
      .then((response) => {
        return response.text();
      })
      .then((intro) => {
        this.setState({ intro });
      })
      .catch((error) => {
        console.log(error);
      })
  };

  boundsChanged = debounce(300, (map) => {
    let bounds = map.getBounds();
    const limitedBounds = map.unproject([0, 0]);

    const hDiff = Math.abs(bounds.getNorth() - limitedBounds.lat);
    const vDiff = Math.abs(bounds.getWest() - limitedBounds.lng);

    bounds = [bounds.getSouth() + hDiff, limitedBounds.lng, limitedBounds.lat, bounds.getEast() - vDiff];
    this.setState({ bounds }, this.filterCreatives);

  });

  setFilter = (e) => {
    const filter = e.target.value;
    this.setState({ filter }, this.filterCreatives);
  };



  filterCreatives = () => {
    const { filter, bounds, tagFilter } = this.state;
    let filteredCreatives = [...this.state.creatives];
    // 1) filter kaartje
    if (bounds.length > 0) {
      filteredCreatives = filteredCreatives.filter(c => {
        const lat = c.location.lat;
        const long = c.location.lon;

        return lat > bounds[0] && long > bounds[1] && lat < bounds[2] && long < bounds[3];
      });
    }
    // 2) filter tekstveld
    if (filter) {
      filteredCreatives = filteredCreatives.filter((creative) => {
          return creative.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1
        }
      );
    }
    // 3) filter tag
    if (tagFilter) {

      filteredCreatives = filteredCreatives.filter((creative) => {
        let match = false;
        for (let i = 0; i < creative.tags.length; i++) {
          if (creative.tags[i].value === this.state.tagFilter) {
            match = true;
          }
        }
        return match;
      })
    }

    this.setState({ filteredCreatives });
  };



  renderAddress = (address) => {
    return (
      <div>
        {address.address_line1 &&
        <div className="address-line">{address.address_line1}</div>
        }
        {address.address_line2 &&
        <div className="address-line">{address.address_line1}</div>
        }
        <div className="address-locality">
          {address.postal_code &&
          <span className="address-loc">{address.postal_code} </span>
          }
          {address.locality &&
          <span className="address-loc">{address.locality}</span>
          }
        </div>
      </div>
    )
  };

  togglePopup = (creative) => {
    this.setState({ showPopup: true, activeCreative: creative });
  };

  clusterMarker = (coordinates, pointCount) => (
    <Marker coordinates={coordinates} style={styles.cluster}>
      {pointCount}
    </Marker>
  );

  resetFilter = () => {
    this.setState({ filteredCreatives: this.state.creatives, filter: '', tagFilter: '' , activeKey: null});
  };







  render() {
    if (this.state.loading) {
      return (
        <div className={"w-100 justify-content-center align-items-center d-flex"}>

          <div className="fa-spin octa-loader" />

        </div>
      )
    }

    return (
      <div className="row creatives-filter">
        <aside className="col-lg-4 pb-2">
          <div className="creatives-stats bg-white hv-bg-light_color position-relative d-flex justify-content-between align-items-center">
            <h1>CREATIVES</h1>

              <h2 className="creative-number py-1">
                {this.state.filteredCreatives.length} / {this.state.creatives.length}
              </h2>


              {/*<div className="creative-arrow py-3 bounce"*/}
              {/*     onClick={() => window.scrollTo(0, this.creativesRef.current.offsetTop)}>*/}
              {/*  <i className="fal fa-arrow-down"></i>*/}
              {/*</div>*/}

          </div>
          <div className="creatives-side">
            {this.state.intro ?
              <div dangerouslySetInnerHTML={{__html: this.state.intro}}/>
              :
              <i className="fas fa-spinner"/>
            }
            <ul>
              <div className="d-flex justify-content-between">

                <span className="pb-3">Filter creatives op categorie:</span>
                {this.state.filteredCreatives.length !== this.state.creatives.length &&
                <div className="reset-creatives" onClick={() => this.resetFilter()}>
                  <i className="fal fa-times"></i>
                </div>
                }
              </div>
              {this.state.tags.map((filter,i) => {

                return (
                  <>
                    <button
                      id='tagButton'
                      key={i}
                      onClick=
                        {() => this.setState({tagFilter: filter.value, activeKey: i}, this.filterCreatives,)}
                      type="radio"
                      name="tagOptions"
                      className={this.state.activeKey === i ? 'active' : '' }
                      value={filter.value}>{filter.value}</button>
                    {/*<label htmlFor={filter.value}>{filter.value}</label>*/}
                  </>
                )
              })}

            </ul>
            <div className="input-group">
              <input className="form-control" type="text" onChange={this.setFilter}
                     placeholder={"Filter op bedrijfsnaam"} value={this.state.filter} />
              <span className="input-group-append">
                                <button className="btn btn-outline-secondary" type="button">
                                    <i className="fa fa-search" />
                                </button>
                            </span>

            </div>
          </div>

        </aside>
        <div className="col-lg-8 pb-2">
          <Map
            onMove={this.boundsChanged}
            onZoom={this.boundsChanged}
            zoom={this.state.zoom}
            center={this.state.center}
            onStyleLoad={(map) => {
              map.scrollZoom.disable();
            }}
            scrollZoom={false}
            style="mapbox://styles/joris-volta/cjqguyu5whw4o2ro7kdfv7myk"
            containerStyle={{
              height: "618px",
              width: "100%"
            }}>
            <ScaleControl />
            <ZoomControl />
            <RotationControl style={{ top: 80 }} />

            {this.state.showPopup && this.state.activeCreative &&
            <Popup
              coordinates={[this.state.activeCreative.location.lon, this.state.activeCreative.location.lat]}
              offset={{
                'bottom-left': [12, -38], 'bottom': [0, -38], 'bottom-right': [-12, -38]
              }}
            >
              <Creative creative={this.state.activeCreative}
                        address={this.renderAddress(this.state.activeCreative.address[0])}
                        compact={true}
              />
            </Popup>
            }

            <Cluster ClusterMarkerFactory={this.clusterMarker} zoomOnClick={true}>
              {
                this.state.filteredCreatives.map(c => {
                    return (
                      <Marker
                        onClick={() => this.togglePopup(c)}
                        coordinates={[c.location.lon, c.location.lat]}
                        key={c.nid}
                        style={styles.marker}
                        className="creative-marker"
                      >
                        <i className="fas fa-map-marker" />
                      </Marker>
                    )
                  }
                )
              }
            </Cluster>
          </Map>
        </div>

        <div className="w-100 mb-4">
          <div className="creatives-list row" ref={this.creativesRef}>
            {this.state.filteredCreatives.length === 0 &&
            <div className="col-12">Geen creatives gevonden...</div>
            }
            {
              this.state.filteredCreatives.map((creative) => {
                const address = creative.address[0] ? creative.address[0] : {};
                return (
                  <div className="col-sm-2 creative-box-ctn" key={creative.nid}>
                    <Creative address={this.renderAddress(address)} creative={creative}
                              compact={false} />
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  cluster: {
    height: '30px',
    width: '30px',
    background: '#000',
    borderRadius: '50%',
    color: '#fff',
    textAlign: 'center',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  marker: {
    fontSize: '15px'
  }

};

export default App;

